import {
  Alert,
  Snackbar,
} from "@mui/material";
import { Button, Flex, Typography } from "antd";
import styles from "../../deliveryServices/DeliveryServices.module.css";
import config from "../../configs";
import UberEatsConnectCard from "./UberEatsConnectCard";

const { Paragraph } = Typography;

export default function UberEatsOnboardingOptions({
  isLoading,
  handleBack,
  handleProvision,
  snackbar,
  handleCloseSnackbar
}) {
  const handleHasExisting = (_has) => {
    const existingUrl = config.url.ueRegistrationLink;
    window.open(existingUrl, "_target");
  };

  return (
    <>
      <UberEatsConnectCard>
        <p className={styles.dsFormLabels}>
          If you already use/have an Uber Eats account for your store and want
          to accept/deny orders in Bevz Retail App on the iPad, please select {' '}
          '<b>Already have an account</b>'.
          <br />
          <br />
          If you don't have an existing account with Uber Eats, and would like
          to Sign Up with them, please select '<b>Don't have an account</b>'. This
          will take you to Uber Eats Sign Up page and after signing up, go
          back here again and select '<b>Already have an account</b>' to
          login to your Uber Eats account.
        </p>
        <br />
        <Flex gap="small" wrap>
          <Button
            type="primary"
            block
            loading={isLoading}
            className={styles.dsLargeButton}
            onClick={handleProvision.bind(this, "add")}
          >
            <p>ALREADY HAVE AN ACCOUNT</p>
          </Button>
          <Button
            color="primary"
            variant="outlined"
            block
            disabled={isLoading}
            className={styles.dsLargeButton}
            onClick={handleHasExisting.bind(this, false)}
          >
            <p>DON'T HAVE AN ACCOUNT</p>
          </Button>
          <Button
            variant="outlined"
            block
            danger
            disabled={isLoading}
            className={styles.dsLargeButton}
            onClick={handleBack}
          >
            <p>CANCEL</p>
          </Button>
        </Flex>
      </UberEatsConnectCard>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          variant="filled"
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};